<template>
  <van-nav-bar
    title="停餐申请"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
  ></van-nav-bar>
  <div style="height: 20px"></div>
  <van-cell-group inset>
    <van-field
      v-model="cause"
      rows="3"
      autosize
      label="停餐原因:"
      type="textarea"
      maxlength="20"
      placeholder="请填写停餐原因"
      show-word-limit
    />
  </van-cell-group>
  <div style="height: 20px"></div>
  <van-cell-group inset>
    <van-field
      v-model="applyDateStr"
      rows="5"
      autosize
      label="停餐日期:"
      type="textarea"
      maxlength="330"
      placeholder=""
      readonly
    />
  </van-cell-group>

  <div style="height: 20px"></div>
  <van-calendar
    v-model:show="showCalendar"
    type="multiple"
    :min-date="startDate"
    :max-date="endDate"
    :default-date="defaultDate"
    @confirm="onConfirm"
    :formatter="formatter"
  />
  <div class="button-container">
    <van-button @click="showCalendar = true" type="primary">选择日期</van-button>
    <van-button
      v-if="showBtn"
      @click="submit"
      color="linear-gradient(to right, #ff6034, #ee0a24)"
      >提交申请</van-button
    >
  </div>
  <div style="height: 20px"></div>
  <van-cell-group inset>
    <van-config-provider :theme-vars="themeVars">
      <van-cell
        title="*请填写停餐原因并点击选择要停餐的日期后再确认提交,9点以后当天不能停餐,周末和法定节假日不需要申请停餐."
      />
    </van-config-provider>
  </van-cell-group>
</template>

<script>
import { onMounted, ref } from "vue";
import api from "../service/api";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const showCalendar = ref(false);
    const showBtn = ref(true);
    const startDate = ref();
    const endDate = ref();
    const applyDateStr = ref("");
    const holidays = ref([]);
    const totalDays = ref(0);
    const defaultDate = ref(null);
    const cause = ref("");
    const router = useRouter(); //传值
    const WORKING_DAY_LABEL = "上班";

    const themeVars = {
      cellTextColor: "#F01526",
    };

    const formatter = (day) => {
      const date = day;
      const dateStr = formatDate(date.date);
      if (holidays.value[dateStr]?.isoffday == 1) {
        date.bottomInfo = holidays.value[dateStr].name;
      } else if (holidays.value[dateStr]?.isoffday == 0) {
        date.bottomInfo = WORKING_DAY_LABEL;
      }
      if (holidays.value[dateStr]) {
        date.className = "red-flag";
      }

      return date;
    };

    const formatDate = (date) =>
      `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`;
    // 检查日期是否为节假日
    const isHoliday = (dateStr) => {
      return holidays.value[dateStr]?.isoffday == 1;
    };
    const onConfirm = (dates) => {
      applyDateStr.value = "";
      // 筛选出非节假日的日期
      const filteredDates = dates.filter((date) => {
        const dateStr = formatDate(date);
        if (isWeekend(dateStr) && (!holidays.value[dateStr] || isHoliday(dateStr))) {
          return false;
        } else if (isHoliday(dateStr)) {
          return false;
        } else {
          return true;
        }
      });

      showCalendar.value = false;
      applyDateStr.value = filteredDates.map(formatDate).join(",");
    };

    function addZero(num) {
      if (num < 10) {
        return "0" + num;
      }
      return "" + num;
    }
    const isWeekend = (dateString) => {
      const date = new Date(dateString.replace(/-/g, "/"));
      // 获取一周中的哪一天，0 表示周日，1 表示周一，以此类推，6 表示周六
      const dayOfWeek = date.getDay();
      // 判断是否为周末
      return dayOfWeek === 0 || dayOfWeek === 6;
    };

    onMounted(() => {
      getHoliday();
      getEatDate();
    });
    /**
     * 提交申请
     */
    const submit = () => {
      if (!cause.value.trim()) {
        Toast("请填写停餐原因");
        return;
      }
      if (!applyDateStr.value.trim()) {
        Toast("请选择日期");
        return;
      }
      api
        .submitAbsenceRequest({
          cause: cause.value,
          absence_request: applyDateStr.value,
          child_id: localStorage.getItem("childId"),
          class_id: localStorage.getItem("classId"),
          school_id: localStorage.getItem("schoolId"),
          phone: localStorage.getItem("phone"),
          child_name: localStorage.getItem("childName"),
          school_name: localStorage.getItem("schoolName"),
          class_name: localStorage.getItem("className"),
          charge_restaurant_id: route.query.charge_restaurant_id,
        })
        .then((res) => {
          if (res.data.code == 34513) {
            Toast(res.data.message);
            cause.value = "";
            applyDateStr.value = "";
          } else {
            Toast(res.data.message);
          }
        });
    };
    /**
     * 获取当年年份
     */
    function getyear() {
      let date = new Date();
      let year = date.getFullYear();
      return year;
    }

    /**
     * 获取节假日
     */
    const getHoliday = () => {
      api
        .getHolidays({
          //获取当年的节假日
          years: getyear(),
        })
        .then((res) => {
          if (res.data.code == 34512) {
            holidays.value = res.data.result;
          } else {
            Toast("获取节假日失败");
          }
        })
        .catch((err) => {
          Toast(err.message);
        });
    };
    /**
     *
     * 获取就餐日期
     */
    const getEatDate = () => {
      api
        .getEatTime({
          child_id: localStorage.getItem("childId"),
          charge_restaurant_id: route.query.charge_restaurant_id,
        })
        .then((res) => {
          if (res.data.code == 34518) {
            let result = res.data.result;

            let now = new Date();
            now.setHours(0, 0, 0, 0);
            let start = new Date(result.eatstartdate.replace(/-/g, "/"));//使用replace是为了兼容ios
            start.setHours(0, 0, 0, 0);
            if (now < start) {//只比较年月日
              startDate.value = new Date(result.eatstartdate.replace(/-/g, "/"));
            } else if (now >= start) {
              if (new Date().getHours() < 9) {
                startDate.value = new Date();
              } else {
                //设置startDate.value为当前日期加1天
                let nextDate = new Date();
                nextDate.setDate(nextDate.getDate() + 1);
                startDate.value = new Date(nextDate);
              }
            }
            endDate.value = new Date(result.eatenddate.replace(/-/g, "/"));
            totalDays.value = result.days;
          } else {
            showBtn.value = false;
          }
        });
    };

    const onClickLeft = () => {
      router.go(-1);
    };

    return {
      showCalendar,
      showBtn,
      onConfirm,
      startDate,
      endDate,
      getHoliday,
      applyDateStr,
      getEatDate,
      totalDays,
      formatDate,
      defaultDate,
      submit,
      cause,
      isWeekend,
      onClickLeft,
      themeVars,
      formatter,
    };
  },
};
</script>

<style scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
}
</style>
